import { Directive } from '@angular/core';

@Directive({
  selector: '[appListSelectGroupHeader]'
})
export class ListSelectGroupHeaderDirective {}
